export const EnDash = () => '\u2013';
